(function () {
  if (window.__hsModelo) return;
  window.__hsModelo = true;

  function heightTxt(cm) {
    var n = parseFloat(cm);
    if (!n) return '';
    return (n / 100).toFixed(2) + ' m';
  }

  var data;
  try { data = JSON.parse(document.getElementById('hs-modelo-data').textContent); } catch (e) { return; }
  if (!data || !data.models || !data.models.length) return;
  var models = data.models;

  function modelForAlt(alt) {
    var m = (alt || '').match(/\[([A-Za-z0-9-]+)\]/);
    if (m) {
      for (var i = 0; i < models.length; i++) if (String(models[i].code).toUpperCase() === m[1].toUpperCase()) return models[i];
      return null;
    }
    return models[0];
  }
  function fileOf(url) {
    return (url || '').split('?')[0].split('/').pop().replace(/_(\d+x\d*|\d*x\d+|\d+w)(?=\.)/, '');
  }
  var byFile = {};
  (data.media || []).forEach(function (m) { byFile[m.file] = m.alt; });

  function captionFor(model) {
    var h = heightTxt(model.altura);
    var txt = 'The model' + (h ? ' is ' + h : '');
    if (model.size) txt += (h ? ' and' : '') + ' wears a size ' + model.size;
    return txt + '.';
  }

  function addCaptions() {
    document.querySelectorAll('media-gallery slideshow-slide, media-gallery .product-media-container').forEach(function (slide) {
      if (slide.closest('dialog')) return;
      if (slide.hasAttribute('data-hs-modelo-checked')) return;
      var img = slide.querySelector('img');
      if (!img) return;
      var alt = byFile[fileOf(img.currentSrc || img.src)];
      if (alt === undefined) alt = img.getAttribute('alt') || '';
      var model = modelForAlt(alt);
      slide.setAttribute('data-hs-modelo-checked', '');
      if (!model || (!model.altura && !model.size)) return;
      var cap = document.createElement('div');
      cap.className = 'hs-modelo-cap';
      cap.textContent = captionFor(model);
      slide.appendChild(cap);
      if (/\[[A-Za-z0-9-]+\]/.test(img.alt)) img.alt = img.alt.replace(/\s*\[[A-Za-z0-9-]+\]\s*/g, ' ').trim();
    });
  }

  var queued = false;
  var mo = new MutationObserver(function () {
    if (queued) return;
    queued = true;
    requestAnimationFrame(function () { queued = false; addCaptions(); });
  });

  function init() {
    addCaptions();
    mo.observe(document.querySelector('main') || document.body, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
